var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-background",class:{ __empty: !_vm.src },style:({ backgroundImage: ("url(" + (_vm.src ? _vm.src : '/img/empty-profile-bg.png') + ")") })})}
var staticRenderFns = []

export { render, staticRenderFns }